(function () {
  var DURATION = 320;

  function panelOf(details) {
    return details.querySelector('.rv-faq__panel');
  }

  function open(details) {
    var panel = panelOf(details);
    details.open = true;
    panel.style.height = '0px';
    panel.offsetHeight;
    panel.style.height = panel.scrollHeight + 'px';
    window.setTimeout(function () {
      if (details.open) panel.style.height = 'auto';
    }, DURATION);
  }

  function close(details) {
    var panel = panelOf(details);
    panel.style.height = panel.scrollHeight + 'px';
    panel.offsetHeight;
    panel.style.height = '0px';
    window.setTimeout(function () {
      details.open = false;
      panel.style.height = '';
    }, DURATION);
  }

  document.querySelectorAll('.rv-faq').forEach(function (section) {
    var items = section.querySelectorAll('details');

    items.forEach(function (details) {
      var summary = details.querySelector('summary');
      if (!summary || !panelOf(details)) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        if (details.open) {
          close(details);
          return;
        }

        items.forEach(function (other) {
          if (other !== details && other.open) close(other);
        });

        open(details);
      });
    });
  });
})();
